/**
 * UUID Utilities
 *
 * Provides UUID v7 generation for better database performance.
 * UUID v7 benefits:
 * - Time-ordered (sortable by creation time)
 * - Better B-tree index performance (sequential inserts)
 * - Embedded timestamp in first 48 bits
 *
 * @module common/utils/uuid
 */

import { v7 as uuidv7 } from 'uuid';

/**
 * Generate a new UUID v7 (time-ordered)
 *
 * @returns UUID v7 string
 * @example
 * const id = generateUUID();
 * // => "018e5f7c-8a9b-7def-8123-456789abcdef"
 */
export function generateUUID(): string {
  return uuidv7();
}
